import { render } from "./fade.vue?vue&type=template&id=ca0766de&lang=pug"
import script from "./fade.vue?vue&type=script&lang=js"
export * from "./fade.vue?vue&type=script&lang=js"

import "./fade.vue?vue&type=style&index=0&id=ca0766de&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__